import {
  Dashboard as DashboardIcon,
  Extension as WidgetIcon,
  Search as SEOIcon,
  SmartToy as BotIcon,
  PhoneAndroid as MobileIcon,
  Speed as PerformanceIcon,
  CheckCircle as CheckIcon,
  ArrowForward as ArrowIcon
} from '@mui/icons-material';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  Button,
  Stack
} from '@mui/material';

const PlatformFeatures2 = () => {
  const features = [
    {
      icon: <DashboardIcon />,
      title: 'Yönetim Paneli',
      description: 'İçerik yönetimi, yetkilendirme ve zamanlama sistemleri'
    },
    {
      icon: <WidgetIcon />,
      title: 'Widget Sistemi',
      description: 'Sürükle-bırak ile esnek sayfa tasarımı'
    },
    {
      icon: <SEOIcon />,
      title: 'SEO Optimizasyonu',
      description: 'Google uyumlu yapı ve arama motoru optimizasyonu'
    },
    {
      icon: <BotIcon />,
      title: 'Ajans Botları',
      description: 'Otomatik haber çekme ve içerik yönetimi'
    },
    {
      icon: <MobileIcon />,
      title: 'Mobil Uyumlu',
      description: 'Responsive tasarım ve native uygulama desteği'
    },
    {
      icon: <PerformanceIcon />,
      title: 'Yüksek Performans',
      description: 'Next.js ile hızlı yükleme ve optimize edilmiş yapı'
    }
  ];

  return (
    <Box sx={{ py: 8, bgcolor: 'white' }}>
      <Container maxWidth="lg">
        {/* Simple Header */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 600,
              mb: 2,
              color: 'text.primary'
            }}
          >
            Dijital Yayıncılık Altyapısı
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: 'text.secondary',
              fontWeight: 400
            }}
          >
            Modern teknoloji ile güçlendirilmiş haber yönetim sistemi
          </Typography>
        </Box>

        {/* Simple Features Grid */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  p: 4,
                  textAlign: 'center',
                  height: '100%',
                  border: 'none',
                  boxShadow: 'none',
                  bgcolor: 'grey.50',
                  borderRadius: 2,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    bgcolor: 'primary.50',
                    transform: 'translateY(-4px)'
                  }
                }}
              >
                <Box
                  sx={{
                    color: 'primary.main',
                    mb: 2,
                    '& svg': {
                      fontSize: 40
                    }
                  }}
                >
                  {feature.icon}
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    mb: 2
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.secondary',
                    lineHeight: 1.6
                  }}
                >
                  {feature.description}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Simple Benefits */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h5" fontWeight={600} gutterBottom>
            Neden Bu Platform?
          </Typography>
          <Grid container spacing={3} sx={{ mt: 2 }}>
            <Grid item xs={12} sm={4}>
              <Box sx={{ p: 3 }}>
                <CheckIcon sx={{ color: 'success.main', fontSize: 32, mb: 1 }} />
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  Kolay Kullanım
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Teknik bilgi gerektirmeden kolayca yönetilebilir
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ p: 3 }}>
                <CheckIcon sx={{ color: 'success.main', fontSize: 32, mb: 1 }} />
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  Hızlı Performans
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Modern teknoloji ile optimize edilmiş hız
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ p: 3 }}>
                <CheckIcon sx={{ color: 'success.main', fontSize: 32, mb: 1 }} />
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  Güvenilir Destek
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  7/24 teknik destek ve sürekli güncellemeler
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Simple CTA */}
        <Box
          sx={{
            textAlign: 'center',
            p: 6,
            bgcolor: 'primary.main',
            color: 'white',
            borderRadius: 2
          }}
        >
          <Typography variant="h4" fontWeight={600} gutterBottom>
            Hemen Başlayın
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, opacity: 0.9 }}>
            Platformumuzu keşfedin ve dijital yayıncılığa adım atın
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent="center"
          >
            <Button
              variant="contained"
              size="large"
              endIcon={<ArrowIcon />}
              sx={{
                bgcolor: 'white',
                color: 'primary.main',
                fontWeight: 600,
                px: 4,
                '&:hover': {
                  bgcolor: 'grey.100'
                }
              }}
            >
              Demo İsteyin
            </Button>
            <Button
              variant="outlined"
              size="large"
              sx={{
                borderColor: 'white',
                color: 'white',
                fontWeight: 600,
                px: 4,
                '&:hover': {
                  borderColor: 'white',
                  bgcolor: 'rgba(255,255,255,0.1)'
                }
              }}
            >
              İletişim
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default PlatformFeatures2;